import { StarIcon } from '@heroicons/react/24/outline';
import { SavedSearch } from '../../../../../../components/ProfileArea/types';
import { getFavoriteSubtitle } from './rightAsideSidebar.utils';

interface FavoritesPanelContentProps {
  isAuthenticated: boolean;
  favoritesLoading: boolean;
  favorites: SavedSearch[];
  onFavoriteClick: (search: SavedSearch) => void;
}

export function FavoritesPanelContent({
  isAuthenticated,
  favoritesLoading,
  favorites,
  onFavoriteClick,
}: FavoritesPanelContentProps) {
  return (
    <div className="min-w-0 py-1 -mx-1">
      {!isAuthenticated ? (
        <p className="px-4 py-2 text-sm text-gray-500 break-words">
          <a href="/login">Sign in</a> to see your saved searches.
        </p>
      ) : favoritesLoading ? (
        <p className="px-4 py-2 text-sm text-gray-500">Loading…</p>
      ) : favorites.length === 0 ? (
        <p className="px-4 py-2 text-sm text-gray-500 break-words">No saved searches yet.</p>
      ) : (
        <ul className="space-y-2 min-w-0 px-1">
          {favorites.map(search => {
            const openLabel =
              search.type === 'score'
                ? 'Apply Score'
                : search.type === 'complete'
                  ? 'Apply All'
                  : search.type === 'columns'
                    ? 'Apply Columns'
                    : 'Open';
            return (
              <li key={search.id} className="min-w-0">
                <button
                  type="button"
                  onClick={() => onFavoriteClick(search)}
                  className="w-full max-w-full rounded-xl border border-[#F1BCD8] bg-[#FFF7FC] px-3 py-2 text-left transition-colors hover:bg-[#FFF0F8] focus:outline-none focus:ring-1 focus:ring-[#be0080]"
                  title={`${search.name} – ${openLabel}`}
                >
                  <div className="flex items-start gap-2">
                    <StarIcon className="mt-0.5 h-4 w-4 flex-shrink-0 text-pink" />
                    <div className="min-w-0">
                      <p className="m-0 truncate text-xs font-semibold text-gray-900">{search.name}</p>
                      <p className="m-0 truncate text-xs text-[#6A7894]">{getFavoriteSubtitle(search)}</p>
                    </div>
                  </div>
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
